import { Root, Leading, Trailing, } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/SidebarBottomItemComponents.js';
import React, { createContext } from 'react';
export const SidebarBottomItemContext = createContext({
    isExpanded: false,
    hasTrailing: false,
    forceSelectionState: false,
});
export const SidebarBottomItem = { Root: Root, Leading: Leading, Trailing: Trailing };
//# sourceMappingURL=SidebarBottomItem.js.map